// -----------新-------------
const aaa = [

	{
		path: "chukuList",
		component: () => import("@/views/chukuNew/list.vue"),
		meta:{title:'出库查询'},
	},
    {
		path: "chukuAdd",
		component: () => import("@/views/chukuNew/add.vue"),
		meta:{title:'出库查询' },
	},
	{
		path: "chukuSee",
		component: () => import("@/views/chukuNew/see.vue"),
		meta:{title:'出库查询'},
	},
	
	
]
export default aaa;